import React from 'react';
import SvgIcon from './SvgIcon';

function VisibilityOffIcon({ width }) {
    return (
        <SvgIcon className="VisibilityOffIcon" width={width}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 18 18"
            >
                <g>
                    <path
                        fill="#666"
                        d="M11.83 9.73l-.843-.843c.113-.62-.064-1.18-.531-1.675-.467-.495-1.04-.687-1.719-.574l-.842-.843A2.588 2.588 0 019 5.567c.85 0 1.573.297 2.167.89.594.595.89 1.317.89 2.168 0 .211-.018.409-.056.591a2.26 2.26 0 01-.171.514zm2.385 2.333l-.828-.776c.475-.362.897-.759 1.266-1.19.369-.431.684-.922.947-1.472a7.372 7.372 0 00-2.69-3.01C11.74 4.873 10.436 4.5 9 4.5c-.363 0-.719.025-1.069.075-.35.05-.694.125-1.031.225l-.874-.874a7.564 7.564 0 011.452-.417A8.523 8.523 0 019 3.375c1.758 0 3.343.485 4.755 1.454a8.445 8.445 0 013.091 3.796 8.471 8.471 0 01-1.077 1.877 8.314 8.314 0 01-1.554 1.561zm.606 4.339l-3.034-3.012A7.945 7.945 0 019 13.875c-1.763 0-3.348-.485-4.755-1.454a8.506 8.506 0 01-3.091-3.796 8.326 8.326 0 011.073-1.854 8.525 8.525 0 011.448-1.492l-2.077-2.1.79-.79L15.612 15.61l-.79.79zM4.465 6.069A8.27 8.27 0 003.31 7.207a6.228 6.228 0 00-.91 1.418 7.373 7.373 0 002.692 3.01C6.259 12.377 7.562 12.75 9 12.75c.341 0 .681-.029 1.02-.087.338-.057.625-.117.86-.178l-.948-.973a2.698 2.698 0 01-.932.17c-.851 0-1.573-.296-2.167-.89-.594-.594-.89-1.316-.89-2.167 0-.152.015-.31.046-.477.03-.165.072-.317.123-.455L4.465 6.07z"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

export default VisibilityOffIcon;
